"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCenterPoint = void 0;
// given an array of long lat coordinates, return the center point
const getCenterPoint = (coordinates) => {
    if (coordinates.length === 1) {
        return coordinates[0];
    }
    let x = 0.0;
    let y = 0.0;
    let z = 0.0;
    for (const coord of coordinates) {
        const latitude = (coord.latitude * Math.PI) / 180;
        const longitude = (coord.longitude * Math.PI) / 180;
        x += Math.cos(latitude) * Math.cos(longitude);
        y += Math.cos(latitude) * Math.sin(longitude);
        z += Math.sin(latitude);
    }
    const total = coordinates.length;
    x = x / total;
    y = y / total;
    z = z / total;
    const centralLongitude = Math.atan2(y, x);
    const centralSquareRoot = Math.sqrt(x * x + y * y);
    const centralLatitude = Math.atan2(z, centralSquareRoot);
    return {
        latitude: (centralLatitude * 180) / Math.PI,
        longitude: (centralLongitude * 180) / Math.PI,
    };
};
exports.getCenterPoint = getCenterPoint;
